import { UserAccuserModel } from "src/app/core/view-models/conferencing";

export const UserAccuserMock: UserAccuserModel = {
    suiT_ACC_DATE: new Date('2003-01-14T00:00:00'),
    suiT_BLACK_NO: 99,
    suiT_BLACK_YEAR: '2546',
    courtName: 'ศาลปกครองกลาง',
    secCode: '',
    items: [],
    suitAccused : "สำนักงานเขตสัมพันธวงศ์",
    suitAccuser : "ห้างหุ้นส่วนจำกัด เอี้ย จื้อ เพียว โดยนายกฤตนัย  แพะวิเศษสิน หุ้นส่วนผู้จัดการ",


}